export const ITEM_DETAILS_TYPES = [
  {
    id: 0,
    name: 'Normal',
    value: 0,
  },
  {
    id: 1,
    name: 'Serialised',
    value: 1,
  },
  // {
  //   id: 2,
  //   name: 'Matrix',
  //   value: 2,
  // },
];

export const BROKERAGE_TYPES = [
  {
    id: 0,
    name: 'None',
    value: 0,
  },
  {
    id: 1,
    name: 'Percentage',
    value: 1,
  },
  {
    id: 2,
    name: 'Quantity Base',
    value: 2,
  },
];

export const ITEM_TYPES = [
  {
    id: 0,
    name: 'Inventory',
    value: 0,
  },
  {
    id: 1,
    name: 'Service',
    value: 1,
  },
  {
    id: 2,
    name: 'Non-inventory',
    value: 2,
  },
  {
    id: 4,
    name: 'Group',
    value: 4,
  },
];
